<template>
  <v-main v-resize="onResize" class="pt-0">
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card class="d-flex pa-1 bg" outlined>
            <div class="mr-auto d-flex">
              <date-time-range-picker-neo v-model="datetimes"></date-time-range-picker-neo>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row style="height: calc(100% - 84px)">
        <v-col cols="4">
          <v-row class="h-100">
            <v-col cols="12">
              <div class="mr-auto d-flex">
                <h3 class="top-title">
                  <v-icon>mdi-circle-medium</v-icon>
                  {{ $t('unulst.ttl.top.user') }}
                </h3>
                <v-spacer></v-spacer>
                <div class="d-flex mt-1">
                  <!-- eslint-disable-next-line prettier/prettier -->
                  <v-text-field
                    v-model="client" :placeholder="this.$t('unulst.filter.client')"
                    class="text-full-width pr-2" style="width: 120px" outlined dense hide-details
                  />
                  <!-- eslint-disable-next-line prettier/prettier -->
                  <v-text-field
                    v-model="user" :placeholder="this.$t('unulst.filter.user')"
                    class="text-full-width" outlined dense hide-details
                  />
                  <v-btn color="primary" class="ml-2" x-small @click="fetch('user')">
                    <v-icon small>mdi-magnify</v-icon>
                  </v-btn>
                  <download-button :loading="downloading.user" :disabled="disableDownloadUser" @download="download('user')"></download-button>
                </div>
              </div>
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-data-table
                :headers="headers.user" :items="items.user" item-key="dataKey"
                :items-per-page="paging.user.rowsPerPage" :loading="loading.user"
                :height="height" class="elevation-1 content"
                fixed-header dense hide-default-footer single-select
                @click:row="highlight"
              >
                <template #item.cnt="{ value }">{{ value | comma }}</template>
                <template #footer>
                  <pagination :paging.sync="paging.user" :length="length.user" :disabled="loading.user"></pagination>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4">
          <v-row class="h-100">
            <v-col cols="12">
              <div class="mr-auto d-flex">
                <h3 class="top-title">
                  <v-icon>mdi-circle-medium</v-icon>
                  {{ $t('unulst.ttl.top.tcode') }}
                </h3>
                <v-spacer></v-spacer>
                <div class="d-flex mt-1">
                  <!-- eslint-disable-next-line prettier/prettier -->
                  <v-text-field
                    v-model="tcode" :placeholder="this.$t('unulst.filter.tcode')"
                    class="text-full-width" outlined dense hide-details
                  />
                  <v-btn color="primary" class="ml-2" x-small @click="fetch('tcode')">
                    <v-icon small>mdi-magnify</v-icon>
                  </v-btn>
                  <download-button :loading="downloading.tcode" :disabled="disableDownloadTcode" @download="download('tcode')"></download-button>
                </div>
              </div>
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-data-table
                :headers="headers.tcode" :items="items.tcode" item-key="tcode"
                :items-per-page="paging.tcode.rowsPerPage" :loading="loading.tcode"
                :height="height" class="elevation-1 content"
                must-sort fixed-header dense hide-default-footer single-select
                @click:row="highlight"
              >
                <template #item.cnt="{ value }">{{ value | comma }}</template>
                <template #footer>
                  <pagination :paging.sync="paging.tcode" :length="length.tcode" :disabled="loading.tcode"></pagination>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4">
          <v-row class="h-100">
            <v-col cols="12">
              <div class="mr-auto d-flex">
                <h3 class="top-title">
                  <v-icon>mdi-circle-medium</v-icon>
                  {{ $t('unulst.ttl.top.report') }}
                </h3>
                <v-spacer></v-spacer>
                <div class="d-flex mt-1">
                  <!-- eslint-disable-next-line prettier/prettier -->
                  <v-text-field
                    v-model="report" :placeholder="this.$t('unulst.filter.report')"
                    class="text-full-width" outlined dense hide-details
                  />
                  <v-btn color="primary" class="ml-2" x-small @click="fetch('report')">
                    <v-icon small>mdi-magnify</v-icon>
                  </v-btn>
                  <download-button :loading="downloading.report" :disabled="disableDownloadReport" @download="download('report')"></download-button>
                </div>
              </div>
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-data-table
                :headers="headers.report" :items="items.report" item-key="name"
                :items-per-page="paging.report.rowsPerPage" :loading="loading.report"
                :height="height" class="elevation-1 content"
                must-sort fixed-header dense hide-default-footer single-select
                @click:row="highlight"
              >
                <template #item.cnt="{ value }">{{ value | comma }}</template>
                <template #footer>
                  <pagination :paging.sync="paging.report" :length="length.report" :disabled="loading.report"></pagination>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapState } from 'vuex';
import { startOfDay } from 'date-fns';
import { api } from '@/api/common/instances';

export default {
  data() {
    return {
      /* search condition */
      datetimes: [startOfDay(new Date()), new Date()],
      client: '',
      user: '',
      tcode: '',
      report: '',
      /* download */
      downloading: {
        user: false,
        tcode: false,
        report: false,
      },
      /* table */
      length: {
        user: 0,
        tcode: 0,
        report: 0,
      },
      paging: {
        user: { page: 1, rowsPerPage: 50 },
        tcode: { page: 1, rowsPerPage: 50 },
        report: { page: 1, rowsPerPage: 50 },
      },
      loading: {
        user: false,
        tcode: false,
        report: false,
      },
      height: 0,
      headers: {
        user: [
          { text: this.$t('unulst.ttl.mandt'), value: 'mandt', sortable: false, width: '30%' },
          { text: this.$t('unulst.ttl.bname'), value: 'bname', sortable: false },
        ],
        tcode: [
          { text: this.$t('unulst.ttl.tcode'), value: 'tcode', sortable: false, width: '30%' },
          { text: this.$t('unulst.ttl.desc'), value: 'ttext', sortable: false },
        ],
        report: [
          { text: this.$t('unulst.ttl.report'), value: 'name', sortable: false, width: '30%' },
          { text: this.$t('unulst.ttl.desc'), value: 'text', sortable: false },
        ],
      },
      items: {
        user: [],
        tcode: [],
        report: [],
      },
      // API
      url: null,
      params: null,
    };
  },
  computed: {
    ...mapState('common/system', ['system']),
    disableDownloadUser() {
      return this.items.user.length == 0 ? true : false;
    },
    disableDownloadTcode() {
      return this.items.tcode.length == 0 ? true : false;
    },
    disableDownloadReport() {
      return this.items.report.length == 0 ? true : false;
    },
  },
  watch: {
    $route: {
      handler: 'onChangeRouteHandler',
    },
    'paging.user': {
      deep: true,
      handler() {
        this.fetch('user');
      },
    },
    'paging.tcode': {
      deep: true,
      handler() {
        this.fetch('tcode');
      },
    },
    'paging.report': {
      deep: true,
      handler() {
        this.fetch('report');
      },
    },
    client() {
      this.items.user = [];
    },
    user() {
      this.items.user = [];
    },
    tcode() {
      this.items.tcode = [];
    },
    report() {
      this.items.report = [];
    },
  },
  methods: {
    onChangeRouteHandler() {
      this.items.user = [];
      this.items.tcode = [];
      this.items.report = [];
    },
    makeFetchParams(urlSuffix) {
      const params = {
        srchBgnYmdhms: this.datetimes[0].getTime(),
        srchEndYmdhms: this.datetimes[1].getTime(),
        sstmId: this.system.id,
        client: this.client,
        user: this.user.toUpperCase(),
        tcode: this.tcode.toUpperCase(),
        report: this.report.toUpperCase(),
      };
      this.url = `/statistics/unused-list${urlSuffix}`;
      this.params = params;
    },
    async fetch(kind) {
      this.makeFetchParams('');
      this.loading[kind] = true;
      const params = this.params;
      params.kind = kind;
      params.page = this.paging[kind].page;
      params.limit = this.paging[kind].rowsPerPage;
      const {
        data: { items, pagination },
      } = await api.get(this.url, { params });
      this.items[kind] = items;
      this.length[kind] = pagination.totalCount;
      this.loading[kind] = false;
    },
    download(kind) {
      this.downloading[kind] = true;
      this.makeFetchParams('-excel');
      const params = this.params;
      params.kind = kind;
      // eslint-disable-next-line prettier/prettier
      api.get(this.url, {params, responseType: 'blob'})
        .then(({ data, headers }) => {
        let filename = '';
        const disposition = headers['content-disposition'];
        if (disposition && disposition.indexOf('attachment') !== -1) {
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
          if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
        }
        const type = headers['content-type'];
        const blob = new Blob([data], { type: type });
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(blob, filename);
        } else {
          const URL = window.URL || window.webkitURL;
          const downloadUrl = URL.createObjectURL(blob);
          if (filename) {
            const a = document.createElement('a');
            if (typeof a.download === 'undefined') {
              window.location = downloadUrl;
            } else {
              a.href = downloadUrl;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
            }
          } else {
            window.location = downloadUrl;
          }
          setTimeout(() => URL.revokeObjectURL(downloadUrl), 100); // cleanup
        }
        this.downloading[kind] = false;
      });
    },
    highlight(item, { isSelected, select }) {
      select(!isSelected);
    },
    onResize() {
      this.height = window.innerHeight - 204;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-full-width {
  width: 190px;
  margin-bottom: 3px;
}
.v-list-item {
  min-height: 28px;
}
.top-title {
  width: 300px;
  padding: 2px 0px 10px 20px;
}
</style>
